import { render, staticRenderFns } from "./OrdersREPLTableDesktop.vue?vue&type=template&id=80958412&scoped=true&"
import script from "./OrdersREPLTableDesktop.vue?vue&type=script&lang=js&"
export * from "./OrdersREPLTableDesktop.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=80958412&scoped=true&lang=css&"
import style1 from "./OrdersREPLTableDesktop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80958412",
  null
  
)

export default component.exports